import commonService from './common-service';

class InvalidOrderDrugService {
  async getInvalidOrderDrugs(limit = 10, pageNum = 1, fil_date = null, filter = null) {
    try {
      let url = `OrderDrug/${limit}/GenerateInvalidDrugOrdersReport?pageNum=${pageNum}`;
      if (fil_date) {
        url += `&fil_date=${fil_date}`;
      }
      if (filter) {
        url += `&filter=${filter}`;
      }
      const response = await commonService.postToServer(url, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async postInvalidOrderDrugAction(data) {

    try {
      const response = await commonService.postToServer("OrderDrug/InvalidDrugOrderAction", data);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getInvalidOrderDrugDefaults() {

    try {
      const response = await commonService.getFromServer("OrderDrug/Defaults", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new InvalidOrderDrugService();